import React from "react";
import "./styles.scss";
import Linkify from "linkifyjs/react";
import { ReactComponent as ReadIcon } from "../../../../../../public/icons/read_icon.svg";
import { isCurrentUser } from "../../../../../../api/sendbird";
import MediaTag from "../../../../shared/MediaTag";
import { filterTimeStamp } from "../../../../../../api/helper";

export default ({ message, reciept }) => {
  let data = message.data ? JSON.parse(message.data) : [];
  return (
    <li className={isCurrentUser(message._sender) ? "self" : "not-self"}>
      <div className="message">
        <Linkify tagName="span" className="text-black">
          {message.message}
        </Linkify>
        {data.map((medium) => (
          <MediaTag className="w-100 bg-white shadow-lg p-2 my-2" medium={medium} showProgress showFullScreenImag />
        ))}
      </div>
      <div className="read_receipt">
        {filterTimeStamp(message.createdAt, reciept)}
        {reciept && <ReadIcon />}
      </div>
    </li>
  );
};
